import { DeheadingReportingTypeEnum, OperationTypeEnum, PassOrFail } from "@gtpl/shared-models/common-models";

export class GrnInfoReq{
    operation: OperationTypeEnum
    inputGrade : number
    physicalQty : number
    batchNumber : string
    plantId : number
    createdUser : string
    grnItemId : number
    grnId?:number
    addonCount?:boolean
    year?:number
    mainBatchNumber?:string
    antibioticTestResult?:PassOrFail

    constructor(operation: OperationTypeEnum,inputGrade : number,physicalQty : number,batchNumber : string,plantId : number,createdUser : string,grnItemId : number,grnId?:number,addonCount?:boolean,year?:number,mainBatchNumber?:string,antibioticTestResult?:PassOrFail){
        this.operation = operation
        this.inputGrade  = inputGrade 
        this.physicalQty  = physicalQty 
        this.batchNumber  = batchNumber 
        this.plantId = plantId
        this.createdUser = createdUser
        this.grnItemId = grnItemId
        this.grnId = grnId
        this.addonCount = addonCount
        this.year = year
        this.mainBatchNumber = mainBatchNumber
        this.antibioticTestResult = antibioticTestResult
    }

}